import { render, staticRenderFns } from "./RelativeRelationTypeForm.vue?vue&type=template&id=e282fac0&"
import script from "./RelativeRelationTypeForm.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports